import { environment } from 'src/environments/environment';

export class Urls {
    apiUrl = environment.apiUrl;
    appUrl = environment.appUrl;
    usmApiUrl = environment.usmApiUrl;
    flmApiUrl = environment.flmApiUrl;
}
